import React, {useMemo} from "react";

import "./ProposalRow.scss";
import Button from "../Button/Button";
import {Link} from "react-router-dom";
import Timer from "../Timer";
import BigNumber from "bignumber.js";
import Separator from "../Separator/Separator";

const MIN_QUORUM_VOTES = new BigNumber(4_000_000).times(10 ** 18);

function ProposalRow({id, title, description, state, open, remaining, data}) {
    const states = {
        0: "Pending",
        1: "Active",
        2: "Canceled",
        3: "Defeated",
        4: "Succeeded",
        5: "Queued",
        6: "Expired",
        7: "Executed"
    };

    let stateClassName = "proposalState";
    if (state && [4, 5, 7, "4", "5", "7"].includes(state)) {
        stateClassName += " passedState";
    } else {
        stateClassName += " opposedState";
    }

    const totalVotes = (new BigNumber(data?.forVotes?.toString() ?? 0)).plus(new BigNumber(data?.againstVotes?.toString() ?? 0));
    const forPercent = (new BigNumber(data?.forVotes?.toString() ?? 0)).div(totalVotes).times(100);
    const againstPercent = (new BigNumber(data?.againstVotes?.toString() ?? 0)).div(totalVotes).times(100);
    const goingToSucceed = totalVotes.gt(0) && forPercent.gt(againstPercent);
    const isEnoughVotesCollected = totalVotes.gt(MIN_QUORUM_VOTES);

    const remainingVotes = () => {
        const diff = MIN_QUORUM_VOTES.minus(totalVotes).div(10 ** 18).toNumber();

        if(diff > 0) {
            return diff.toLocaleString("ru-RU", { maximumFractionDigits: 2 })
        } else {
            return "0";
        }
    };

    // const { windowWidth } = useResize();
    //
    // const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    return (
        <div className="proposal-row">
            <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
                <div>
                    <span className="proposal-row-title">{title}</span>
                    {open ? (
                        <React.Fragment>
                            <div className="proposal-end-mob">
                                <div className="proposalEnd">
                                    <span className="proposalEndText">Ends In:</span>
                                    <Timer remaining={remaining}/>
                                </div>
                                {open && (
                                    <Link to={`/voting/${id}`}>
                                        <Button>Go To Proposal</Button>
                                    </Link>
                                )}
                            </div>
                            <span style={{color: goingToSucceed && isEnoughVotesCollected ? "var(--green1)" : "var(--red)", fontWeight: 800}}>
                                Going to {goingToSucceed && isEnoughVotesCollected ? "Succeed " : "Fail "}
                                {!isEnoughVotesCollected && `(collected votes didn't pass quorum minimal threshold, ${remainingVotes()} more votes need)`}
                                <br />
                                {
                                  totalVotes.gt(0)
                                  && `(${forPercent.toFixed(0)}% For, ${againstPercent.toFixed(0)}% Against)`
                                }
                            </span>
                        </React.Fragment>
                    ) : ( state &&
                        <div className={stateClassName}>
                            <span className="stateText">{states[state]}</span>
                        </div>
                    )}
                    <Separator />
                </div>
                {/*{!mobileView && open && (*/}
                {/*    <Link to={`/voting/${id}`}>*/}
                {/*        <Button>Go To Proposal</Button>*/}
                {/*    </Link>*/}
                {/*)}*/}
            </div>
            <span className="proposalDescription">{description}</span>
        </div>
    );
}

export default ProposalRow;
